<div class="sidebar-reference-about"><app-loading [isLoading]="!!!reference">
    <div class="card v-card fadeIn" *ngIf="reference">
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-6">
            <h5 class="card-title">{{ 'SIDEBAR.IP_ADDRESS' | translate }}</h5>
            <p class="text-muted">{{ reference?.metadatum?.ip_address || '-' }}</p>
            <h5 class="card-title">{{ 'SIDEBAR.BROWSER' | translate }}</h5>
            <p class="text-muted">{{ reference?.metadatum?.browser || '-' }}</p>
            <h5 class="card-title">{{ 'SIDEBAR.BROWSER_VERSION' | translate }}</h5>
            <p class="text-muted">{{ reference?.metadatum?.browser_version || '-' }}</p>
            <h5 class="card-title">{{ 'SIDEBAR.DEVICE' | translate }}</h5>
            <p class="text-muted">{{ reference?.metadatum?.device || '-' }}</p>
            <h5 class="card-title">{{ 'SIDEBAR.OS' | translate }}</h5>
            <p class="text-muted">{{ reference?.metadatum?.os || '-' }}</p>
            <h5 class="card-title">{{ 'SIDEBAR.OS_VERSION' | translate }}</h5>
            <p class="text-muted">{{ reference?.metadatum?.os_version || '-' }}</p>
            <h5 class="card-title">{{ 'SIDEBAR.USER_AGENT' | translate }}</h5>
            <p class="text-muted">{{ reference?.metadatum?.user_agent || '-' }}</p>
          </div>
          <div class="col-12 col-md-6">
            <h5 class="card-title">{{ 'COMMON.CREATED_AT' | translate }}</h5>
            <p class="text-muted">{{ reference?.created_at | dateFormat : 'MMM DD, YYYY hh:mma' }}</p>
            <h5 class="card-title">{{ 'COMMON.UPDATED_AT' | translate }}</h5>
            <p class="text-muted">{{ reference?.updated_at | dateFormat : 'MMM DD, YYYY hh:mma' }}</p><ng-container *ngIf="!!reference?.signature_url">
              <h5 class="card-title">{{ 'SIDEBAR.SIGNATURE' | translate }}</h5><img class="w-50" [src]="reference.signature_url" />
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </app-loading></div>
